import { staticFile } from "remotion";
import { CinematicRendererProps } from "./types";

export const signalFromTomorrowWithMusicFixture: CinematicRendererProps = {
  titleFontSize: 78,
  titleWidth: 1320,
  signalLineCount: 18,
  soundtrack: {
    src: staticFile(
      "music/signal-from-tomorrow/cinematic_time_hans_zimmer_style.mp3",
    ),
    volume: 0.42,
    fadeInSeconds: 1.5,
    fadeOutSeconds: 2.5,
  },
  scenes: [
    {
      id: "sc1",
      kind: "video",
      startSeconds: 0,
      durationSeconds: 4,
      src: staticFile("video/signal-from-tomorrow/sample_observatory_veo31_ref.mp4"),
      tone: "cold",
      trimBeforeSeconds: 1,
      fadeInFrames: 0,
    },
    {
      id: "sc2",
      kind: "video",
      startSeconds: 4,
      durationSeconds: 4,
      src: staticFile(
        "video/signal-from-tomorrow/sc2_mission_control_veo31_ref_8s.mp4",
      ),
      tone: "steel",
    },
    {
      id: "sc3",
      kind: "title",
      startSeconds: 8,
      durationSeconds: 3,
      text: "YESTERDAY, THEY LAUNCHED.",
      accent: "#89d7ff",
      intensity: 1,
    },
    {
      id: "sc4",
      kind: "video",
      startSeconds: 11,
      durationSeconds: 7,
      src: staticFile("video/signal-from-tomorrow/sc4_launch_departure_veo31_ref.mp4"),
      tone: "cold",
    },
    {
      id: "sc5",
      kind: "title",
      startSeconds: 18,
      durationSeconds: 3,
      text: "THE SIGNAL CAME FROM EARTH.",
      accent: "#a6e6ff",
      intensity: 1.15,
    },
    {
      id: "sc6",
      kind: "video",
      startSeconds: 21,
      durationSeconds: 6,
      src: staticFile(
        "video/signal-from-tomorrow/sc6_orbital_paradox_veo31_ref_8s.mp4",
      ),
      tone: "void",
    },
    {
      id: "sc7",
      kind: "title",
      startSeconds: 27,
      durationSeconds: 3,
      text: "SIGNAL FROM TOMORROW",
      accent: "#d6f1ff",
      intensity: 0.9,
    },
  ],
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
